import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import PropTypes from "prop-types";

function TopMessage({ visible, message, title, subtitle, closing }) {
    if (!visible) return null;

    return (
        <MDBox
            position="fixed" // Fixed to top of viewport
            top="0"
            left="0"
            width="100%"
            bgColor="white"
            variant="gradient"
            coloredShadow="dark"
            py={4}
            px={4}
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={3}
            sx={{
                zIndex: 9999, // Maximum z-index to overlay everything
                animation: closing
                    ? "slideUp 0.8s ease-in forwards" // Slower exit for emphasis
                    : "slideDown 0.5s ease-out forwards",
                borderBottom: "4px solid #FFB347", // Theme orange accent
            }}
        >
            <style>
                {`
                    @keyframes slideDown {
                        from { transform: translateY(-100%); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                    @keyframes slideUp {
                        from { transform: translateY(0); opacity: 1; }
                        to { transform: translateY(-100%); opacity: 0; }
                    }
                `}
            </style>

            <TipsAndUpdatesIcon color="warning" fontSize="large" sx={{ fontSize: "40px !important" }} />

            {title ? (
                <MDBox textAlign="left">
                    <MDTypography variant="h4" fontWeight="bold" color="dark" display="block">
                        {title}
                    </MDTypography>
                    {subtitle && (
                        <MDTypography variant="h6" fontWeight="regular" color="dark" display="block" mt={0.5}>
                            {subtitle}
                        </MDTypography>
                    )}
                </MDBox>
            ) : typeof message === "string" ? (
                <MDTypography variant="h4" fontWeight="bold" color="dark" textAlign="center">
                    {message}
                </MDTypography>
            ) : (
                <MDBox textAlign="left">
                    {message}
                </MDBox>
            )}
        </MDBox >
    );
}

TopMessage.propTypes = {
    visible: PropTypes.bool.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    closing: PropTypes.bool,
};

export default TopMessage;
